import { Pagination, Popconfirm, Switch, Table } from 'antd';
import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  APPLICATION_ID, authFeatureConstants, DEFAULT_PAGE_SIZE, INVENTORY_MESSAGE_CONSTANTS, INVENTROY_CONSTANTS, PAGE_QUERY_PARAM,
  StatusFilterType,
} from '../../../../shared/constants/commonConstants';
import { INVENTORY_SAVE_IP_PACKAGE } from '../../../../shared/constants/urlEndPoints';
import { IPPackageDTO, SaveInPatientPackageRequest, SaveInPatientPackageResponse } from '../../../../shared/models/inPatient.model';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { base64UrlEncode, canActivate, error, extractSecondLevelBaseUrl, formatPrice, GetFirstElement, success } from '../../../../utils/utility';
import './IPPackagesList.less';
import { ReactComponent as ApprovedIcon  } from '../../../../assets/images/svg/i_approved.svg';
import { ReactComponent as PendingIcon  } from '../../../../assets/images/svg/i_pending.svg';
import { ReactComponent as RejectedIcon  } from '../../../../assets/images/svg/i_rejected.svg';

const IPPackagesList = ({ match: { path }, packageItems, rooms, currentPageNo, totalRecords, onPaginationEvent }: any): ReactElement => {
  const history = useHistory();
  const [packageList, setPackageList] = useState(null as any);
  useEffect((): void => {
    setPackageList(packageItems);
  }, [packageItems]);

  const rowClick = (record: any): any => {
    history.push(extractSecondLevelBaseUrl(path) + INVENTROY_CONSTANTS.ipPackageDetailRoute +
      base64UrlEncode(record.key) + PAGE_QUERY_PARAM + currentPageNo);
  };
  const onChangeSwitch = (value: any, record: any): any => {
    const packageData = packageList.filter((item: any): any => item.id === record.key);
    if (!packageData) {
      return;
    }
    const payload: SaveInPatientPackageRequest = {
      applicationId: APPLICATION_ID,
      package: {
        ...GetFirstElement(packageData), isActive: !record.isActive, inclusionList: [], pricingList: [],
      },
    };
    onSavePackage(payload);
  };

  const onSavePackage = async (payload: SaveInPatientPackageRequest): Promise<void> => {
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + INVENTORY_SAVE_IP_PACKAGE;
    const result: SaveInPatientPackageResponse = await SendRequest.instance.post<
      SaveInPatientPackageRequest,
      SaveInPatientPackageResponse
    >(url, payload);
    if (result && result.isSuccess) {
      const index = packageList.findIndex((item: any): any => item.id === payload.package.id);
      const newPackageList = [...packageList];
      packageList[index].isActive = payload.package.isActive;
      packageList[index].isApproved = false;
      packageList[index].statusName = StatusFilterType.isSubmit;
      setPackageList(newPackageList);
      success(`Package ${payload.package.isActive ? 'enabled' : 'disabled'} successfully`);
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.tryAgain);
    }
  };
  const dataSource: any[] | undefined = [];
  const columns = [
    {
      title: 'Active',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (e: any, record: any): any => (
        <div onClick={(event: any): any => event.stopPropagation()}>
          <Popconfirm
            disabled={!canActivate(authFeatureConstants.EDIT_IP_PACKAGES)}
            title={record?.isActive ? INVENTORY_MESSAGE_CONSTANTS.isDeActivatePackage : INVENTORY_MESSAGE_CONSTANTS.isActivatePackage}
            onConfirm={(value: any): any => onChangeSwitch(value, record)}
            okText="Yes"
            cancelText="No"
          >
            <Switch size="small"
              disabled={!canActivate(authFeatureConstants.EDIT_IP_PACKAGES)}
              checked={record?.isActive}
            />
          </Popconfirm>
        </div>
      ),
    },
    {
      title: 'Name',
      dataIndex: 'packageName',
      key: 'packageName',
      className: 'mouse-pointer',
    },
    {
      title: 'Department',
      dataIndex: 'groupName',
      key: 'groupName',
    },
    {
      title: 'Price Range',
      dataIndex: 'priceMinMax',
      key: 'priceMinMax',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text: any, record: any): ReactNode => {
        switch (record.statusName) {
          case StatusFilterType.isApproved:
            return <div className="status verified" >
              <ApprovedIcon className="fill-approved v-align-sub" /> Verified
                </div>;
          case StatusFilterType.isSubmit:
            return <div className="status pending">
              <PendingIcon className="fill-pending v-align-sub" /> Pending
                </div>;
          case StatusFilterType.isRejected:
            return <div className="status rejected">
              <RejectedIcon className="fill-rejected v-align-sub" /> Rejected
                </div>;
          default:
            return <div className="status pending">
              <PendingIcon className="fill-approved v-align-sub" /> Pending
                </div>;
        }
      },
    },
  ];

  if (packageList) {
    packageList.map((ip: IPPackageDTO): void => {
      const price = ip?.pricingDetails?.length ? ip?.pricingDetails : null as any;
      const minMax = price?.map((val: any): void => val?.discountedPrice);
      let min = 0;
      let max = 0;
      if (minMax) {
        min = Math.min(...minMax);
        max = Math.max(...minMax);
      }
      const obj = {
        key: ip.id,
        isActive: ip.isActive,
        packageName: ip.procedureName,
        groupName: ip.departmentName,
        statusName: ip.statusName,
        priceMinMax: min === max ? formatPrice(min, false) : formatPrice(min, false) + ' - ' + formatPrice(max, false, false),
      };
      dataSource.push(obj);
    });
  }
  return (
    <div>
      {(columns && packageList && currentPageNo && totalRecords && dataSource && dataSource.length) &&
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          onRow={(record: any, rowIndex: any): any => {
            return {
              onClick: (event: any): any => { rowClick(record); },
            };
          }}
        />
      }
      {(dataSource && dataSource.length > 0 && totalRecords) &&
          <Pagination
            defaultCurrent={currentPageNo}
            defaultPageSize={DEFAULT_PAGE_SIZE}
            total={totalRecords} onChange={(page: number, pagesize: any): any => onPaginationEvent(page, pagesize)}
            className="mt-md text-center" />
      }
    </div>
  );
};

export default IPPackagesList;
